import { render, staticRenderFns } from "./ucit-bar-chart-performance-set.vue?vue&type=template&id=7f47c690&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports